// App name: Detail LKW  Form
// Description:

const detailLkwForm = (function ($) {

  // variables
  let _form = $('.lkw_form form.cart');
  let _yithBlock = _form.find('.yith-wapo-block');

  // init
  function init() {
    replaceSelectHolder();
  }

  function replaceSelectHolder() {

    var _yithAddon = _yithBlock.find('.yith-wapo-addon');

    // Loop and replace all text of first option in select box
    _yithAddon.each(function(index) {
      var _placeholderText = $(this).find('h3').text().trim();
      $(this).find('select option').first().text(`${_placeholderText} auswählen`);
    });
  }

  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  detailLkwForm.init();
});
